<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="content_wrap container">
      <div class="content_title">
        <!-- type 1 会议日程 2 线上课程-->
        <titleConfig
          v-if="type == 1"
          :title="langSet == 'cn' ? '会议日程' : 'Conference Schedule'"
          :type="2"
        ></titleConfig>
        <titleConfig
          v-if="type == 2"
          :title="langSet == 'cn' ? '线上课程' : 'Online Courses'"
          :type="2"
        ></titleConfig>
      </div>
      <template v-if="type == 1">
        <div class="content_tab flex">
          <div class="tab_title">{{ langSet == 'cn' ? '会议板块' : 'Conference Section'}}</div>
          <div class="tab_list flex">
            <div
              :class="{ active: item.id == plateId }"
              v-for="(item, index) in plateOptions"
              :key="index"
              @click="changePlate(item.id)"
            >
              {{ langSet == 'cn' ? item.name : item.en_name }}
            </div>
          </div>
        </div>
        <div class="content_tab flex border_b">
          <div class="tab_title">{{ langSet == 'cn' ? '选择日期' : 'Select Date'}}</div>
          <div class="tab_list flex">
            <div
              :class="{ active: item.starttime == timeValue }"
              v-for="(item, index) in timeOptions"
              :key="index"
              @click="changeTime(item.starttime)"
            >
              <template v-if="item.starttime == '不限'">
                {{ langSet == 'cn' ? item.starttime : 'All'}}
              </template>
              <template v-else>{{ item.starttime }}</template>
            </div>
          </div>
        </div>
      </template>
      <active :list="list" :type="type"></active>
      <nodata v-if="list.length == 0"></nodata>
      <div class="page_wrap flex flex_content_center">
        <el-pagination
          v-if="totals > 6"
          background
          layout="prev, pager, next"
          :total="totals"
          :page-size="type == 1 ? 9 : 6"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import active from "@/components/active.vue";
import nodata from "@/components/nodata.vue";
import {
  offlineMeetList,
  onlineCourseList,
  plateLists,
  offlineMeetTimeLists,
} from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
    active,
    nodata,
  },
  data() {
    return {
      langSet: "",
      list: [],
      metaData: {},
      type: "",
      totals: 0,
      pageNo: 1,
      pageSize: 9,
      plateOptions: [
        {
          id: "",
          name: "不限",
          en_name: 'All'
        },
      ],
      plateId: "",
      timeOptions: [
        {
          starttime: "不限",
        },
      ],
      timeValue: "",
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    this.type = this.$route.query.type;
    this.pageNo = 1;
    //25.9.16 获取列表 dxm
    if (this.type == 1) {
      this.getPlateLists();
      this.getOfflineMeetTimeLists();
      this.getOfflineMeetList();
    } else {
      this.pageSize = 6;
      this.getList();
    }
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getPlateLists() {
      const res = await plateLists();
      this.plateOptions = [...this.plateOptions, ...res.data.lists];
      this.plateId = this.plateOptions[0].id;
    },
    async getOfflineMeetList() {
      let data = {
        starttime: this.timeValue == "不限" ? "" : this.timeValue,
        plate_idstr: this.plateId,
        page_no: this.pageNo,
        page_size: this.pageSize,
      };
      const res = await offlineMeetList(data);
      this.list = res.data.lists;
      this.totals = res.data.count;
    },
    async getOfflineMeetTimeLists() {
      const res = await offlineMeetTimeLists();
      this.timeOptions = [...this.timeOptions, ...res.data];
      this.timeValue = this.timeOptions[0].starttime;
    },
    async getList() {
      let data = {
        page_no: this.pageNo,
        page_size: this.pageSize,
      };
      const res = await onlineCourseList(data);
      this.list = res.data.lists;
      this.totals = res.data.count;
    },
    changePlate(id) {
      this.plateId = id;
      this.getOfflineMeetList();
    },
    changeTime(value) {
      this.timeValue = value;
      this.getOfflineMeetList();
    },
    currentChange(e) {
      this.pageNo = e;
      if (this.type == 1) {
        this.getOfflineMeetList();
      } else {
        this.getList();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content_wrap {
  padding: 80px 0;
  min-height: 500px;
  .content_title {
    margin-bottom: 31px;
  }
  .content_tab {
    padding-bottom: 16px;
    .tab_title {
      font-weight: 500;
      font-size: 18px;
      color: #001a33;
      line-height: 25px;
    }
    .tab_list {
      flex: 1;
      flex-wrap: wrap;
      color: #555;
      font-size: 18px;
      line-height: 32px;
      padding-left: 40px;
      div {
        height: 32px;
        cursor: pointer;
        margin: 0 30px 16px 0;
      }
      .active {
        color: #fff;
        padding: 0 12px;
        background: #1d2379;
        border-radius: 6px;
      }
    }
  }
  .border_b {
    border-bottom: 5px solid #eee;
    margin-bottom: 30px;
  }
  .page_wrap {
    margin-top: 40px;
  }
}
@media only screen and (max-width: 767px) {
  .content_wrap {
    padding: 0.58rem 0;
    .content_title {
      margin-bottom: 0.58rem;
    }
    .content_tab {
      padding-bottom: 10px;
      .tab_title {
        font-size: 16px;
        line-height: 25px;
      }
      .tab_list {
        font-size: 16px;
        line-height: 28px;
        padding-left: 20px;
        div {
          height: 28px;
          cursor: pointer;
          margin: 0 10px 10px 0;
        }
        .active {
          color: #fff;
          padding: 0 12px;
          background: #1d2379;
          border-radius: 6px;
        }
      }
    }
  }
}
</style>